import { FC } from "react";
import {
  Center,
  HStack,
  Separator,
  Text,
  tokens,
} from "shared/components/Spor";
import styled from "styled-components";
/*
import { DashboardHistoryTabs } from "features/Header/DashboardHistoryTabs";
*/
import { getBackendEnvParsedSafe } from "api/common";
import { Environment, environment } from "app/environment/environment";
import Clock from "features/Header/Clock/Clock";
import { Logo } from "features/Header/Logo/Logo";
import { Menu } from "features/Header/Menu/Menu";
import Puzzel from "features/Header/PuzzelTelephone/Puzzel";
import SelectRole from "features/Header/SelectRole/selectRole";
import { OpenAlerts } from "features/Header/TrainResumed/OpenAlerts";
import { useLocation } from "react-router-dom";
import { capitalize } from "shared/utils/objectUtils";
import * as ROUTES from "shared/utils/routes";
import { useDropsRole } from "stores/useDropsRole";

export const HeaderWrapper = styled.div`
  grid-area: header;
  height: 4rem;
  font-weight: 300;
  font-size: 15px;
  align-self: stretch;
  z-index: ${tokens.default.depth["z-index"].banner};
  display: flex;
  margin: 0px 12px;
  border-radius: 6px;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
`;

const SeparatorContainer = () => (
  <Center height="60%">
    <Separator
      size="lg"
      borderLeftWidth="1px"
      orientation="vertical"
      style={{ margin: "12px" }}
    />
  </Center>
);

const env: Environment = environment();

const Header: FC = () => {
  const location = useLocation();
  const { isVaktleder } = useDropsRole();
  if (location.pathname === ROUTES.OPLOGG) {
    return null;
  }
  return (
    <HeaderWrapper>
      <HStack px="18px" separator={<SeparatorContainer />}>
        <Logo />
        <Clock />
      </HStack>
      {env !== Environment.Production && (
        <Text fontSize="2xl" as="span" flex="1" textAlign="left" color="red">
          {capitalize(
            env === Environment.Development
              ? getBackendEnvParsedSafe("VITE_BACKEND_ENV")
              : env.toLowerCase(),
          )}
        </Text>
      )}
      <HStack separator={<SeparatorContainer />}>
        {isVaktleder() && <OpenAlerts />}
        <Puzzel />
        <SelectRole />
        <Menu />
      </HStack>
    </HeaderWrapper>
  );
};

export default Header;
